import InvestorMyDealsPage from "./InvestorMyDealsPage";
export default InvestorMyDealsPage;
